import {
  InvoiceDiscrepancy,
  useSiteInvoiceValidation,
} from "@inrange/building-manager-api-client";
import { useEffect } from "react";

const FIELD_LABELS: Record<string, string> = {
  consumptionKwh: "Consumption (kWh)",
  onSiteTariffRate: "On-site tariff rate",
  consumptionCharges: "Consumption charges",
  subtotal: "Subtotal",
  vatRate: "VAT rate",
  vatAmount: "VAT amount",
  total: "Total",
  generatedKwh: "Generated (kWh)",
  spillTariffRate: "Spill tariff rate",
  ooRevenueSharePct: "Revenue share %",
  ooRevenueShareAmount: "Revenue share amount",
  otherChargeItemCount: "Other charges",
};

const fieldLabel = (field: string) => FIELD_LABELS[field] ?? field;

// Component that validates an invoice file automatically
const InvoiceValidation = ({
  siteId,
  fileGuid,
  month,
  onIcon,
}: {
  siteId: string;
  fileGuid: string;
  month: string;
  onIcon?: (icon: string | null) => void;
}) => {
  const { fetchInvoiceValidation } = useSiteInvoiceValidation({
    siteId,
    fileGuid,
    month,
    enabled: !!fileGuid && !!month,
  });

  const result = fetchInvoiceValidation.data;
  const isLoading = fetchInvoiceValidation.isFetching;

  useEffect(() => {
    if (!onIcon) return;
    if (isLoading || !result) {
      onIcon(null);
    } else if (result.isValid) {
      onIcon("\u2705");
    } else {
      onIcon("\u274C");
    }
  }, [onIcon, isLoading, result]);

  if (isLoading) {
    return (
      <span
        style={{ fontWeight: "normal", fontStyle: "italic", color: "#666" }}
      >
        {" "}
        (validating...)
      </span>
    );
  }

  if (!result) return null;

  const mismatches = result.discrepancies.filter(
    (d: InvoiceDiscrepancy) => d.issue === "mismatch"
  );

  if (result.isValid) {
    return null;
  }

  return (
    <div style={{ fontWeight: "normal" }}>
      <div
        style={{
          fontSize: "0.85em",
          color: "#dc3545",
          marginTop: "4px",
        }}
      >
        {mismatches.map((d: InvoiceDiscrepancy) => (
          <div key={d.field}>
            {"• "}
            {fieldLabel(d.field)}: expected{" "}
            {d.expected != null ? String(d.expected) : "-"}, found{" "}
            {d.extracted != null ? String(d.extracted) : "-"}
          </div>
        ))}
      </div>
    </div>
  );
};

export default InvoiceValidation;
